import * as React from 'react';
import IconButton from '@material-ui/core/IconButton';
import Avatar from '@material-ui/core/Avatar';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ExitToApp from '@material-ui/icons/ExitToApp';
import Card from '@material-ui/core/Card';
import Typography from '@material-ui/core/Typography';
import CardContent from '@material-ui/core/CardContent';
import { Grid, Theme, createStyles, WithStyles, withStyles, Chip } from '@material-ui/core';
import { DeltaJSONColors, DeltaXMLColors } from '../styling/DeltaColors';
import { AuthContext } from './AuthContext';
import { Themes } from '../styling/Themes';
import { CustomerSubscription, SubsData } from './SubscriptionData';

export interface ProfileDetails {
    emailAddress: string,
    avatarPicture: string
}

const styles = (theme: Theme) =>
    createStyles({
        profileLabels: {
            margin: '0px 0px 0px 0px',
            height: '41px',
            width: '240px',
            fontWeight: 'bold',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            color: DeltaJSONColors.WHITE
        },
        avatar: {
            width: theme.spacing(12),
            height: theme.spacing(12),
            fontSize: '45px',
            justifyContent: "center",
            backgroundColor: DeltaXMLColors.ORANGE
        },
        avatarGrid: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        },
        card: {
            backgroundColor: DeltaJSONColors.BREAKER_BAY,
            minWidth: 400,
            maxWidth: 650
        },
        menuItem: {
            paddingBottom: 20
        }
    });

export interface ProfileProps extends WithStyles<typeof styles> {
    profileDetails: ProfileDetails,
    customerSubscriptionData: CustomerSubscription
}

function ProfileButton(props: ProfileProps) {
    const { classes, profileDetails, customerSubscriptionData } = props;
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const auth = React.useContext(AuthContext);
    const subscriptionStatus = SubsData.statusTextMap.get(customerSubscriptionData.subscriptionStatus);

    function logout() {
        setAnchorEl(null);
        auth.logout();
    }

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <Themes.HtmlTooltip arrow interactive
                title={
                    <Typography variant="body2" color="inherit">
                        Profile Settings
                    </Typography>
                }>
                <IconButton onClick={handleClick}>
                    <Avatar style={{backgroundColor: DeltaXMLColors.ORANGE, fontSize: '16px'}}>{profileDetails.avatarPicture}</Avatar>
                </IconButton>
            </Themes.HtmlTooltip>
            <Menu keepMounted open={Boolean(anchorEl)} onClose={handleClose} anchorEl={anchorEl}>
                <Card className={classes.card}>
                    <CardContent>
                        <Grid container spacing={1}>
                            <Grid item xs={9}>
                                <Grid item xs={12}>
                                    <Typography className={classes.profileLabels}>{profileDetails.emailAddress}</Typography>
                                </Grid>
                                <Grid item xs={9}>
                                    <Chip label={subscriptionStatus} avatar={<Avatar>{subscriptionStatus!.charAt(0)}</Avatar>} color="primary" />
                                </Grid>
                            </Grid>
                            <Grid item xs={3} className={classes.avatarGrid}>
                                <Avatar className={classes.avatar}>{profileDetails.avatarPicture}</Avatar>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
                <br />
                <MenuItem button className={classes.menuItem} onClick={logout}>
                    <ListItemIcon> <ExitToApp /> </ListItemIcon>
                    <Typography color="primary" variant="h6">
                        Sign Out
                    </Typography>
                </MenuItem>
            </Menu >
        </>
    )

}


export default withStyles(styles)(ProfileButton);